import { Suspense, useEffect, useMemo, useState } from "react"
import { FaSort } from "react-icons/fa"
import { useSelector } from "react-redux"
import NewMeComponent from "../../component/NewMeComponent"
import useToggleShortlisted from "../../hooks/useToggleShortlistedTrend"
import { SentenceCase } from "../../utility/helper_functions"
import roundtocloses0_5_value from "../V2Leaderboard/Utils/roundToClosest_0_5"
import showFloatToPercentage from "../V2Leaderboard/Utils/showFloatToPercentage"
import CopyNewmeProductUrlsButton from "./CopyNewmeProductUrlButton"
import SilhouetteShare from "./SilhouetteShare/SilhouetteShare"
import TabularDataRetailerCell from "./TabularDataForRetailer"
import NewmeTabularDataRetailerCell from "./TabularTrends/NewmeRetailerCell"
import ShortlistTrend from "./TabularTrends/ShortlistTrend"

const companyToRetailer = {
  'cocoblu': 'Cocoblu',
  'trend': 'westside',
  'newme': 'newme'
}

const LENGTHCATEGORIES = new Set([
  'Coats & Blazers',
  'Coats, Suits, Blazers',
  'Dresses',
  'Dungaree',
  'Ethinic Wear',
  'Jackets',
  'Jeans',
  'Jumpsuits',
  'Leggings',
  'Lounge Coords',
  'Other Outerwear',
  'Shirts',
  'Shorts',
  'Skirts',
  'Skorts',
  'Sweaters & Cardigans',
  'Sweatshirts & Hoodies',
  'Topwear',
  'Track/ Sweat/ Pyjama Pants',
  'Trousers',
  'Tshirts'
])

const NECKLINECATEGORIES = new Set([
  'Coats & Blazers',
  'Coats, Suits, Blazers',
  'Dresses',
  'Dungaree',
  'Ethinic Wear',
  'Jackets',
  'Jumpsuits',
  'Lingerie & Swimwear',
  'Lounge Coords',
  'Other Outerwear',
  'Shirts',
  'Sweaters & Cardigans',
  'Sweatshirts & Hoodies',
  'Swim wear',
  'Topwear',
  'Tshirts'
])

const showLengthColumn = (searchedCategory) => {
  if (!searchedCategory || searchedCategory == '' || searchedCategory == 'apparel' || searchedCategory.split(',,').reduce((prev, current) => prev || LENGTHCATEGORIES.has(current), false))
    return true
  return false
}

const showNecklineColumn = (searchedCategory) => {
  if (!searchedCategory || searchedCategory == '' || searchedCategory == 'apparel' || searchedCategory.split(',,').reduce((prev, current) => prev || NECKLINECATEGORIES.has(current), false))
    return true
  return false
}

const NOSORTKEY = ''
const FORECASTASCENDINGSORT = 'forecast-asc'
const FORECASTDESCNDINGSORT = 'forecast-desc'
const RETAILERCOUNTASCENDINGSORT = 'retailer-count-asc'
const RETAILERCOUNTDESCENDINGSORT = 'retailer-count-desc'
const TOTALRETAILERCOUNTASCENDINGSORT = 'ret-count-asc'
const TOTALRETAILERCOUNTDESCENDINGSORT = 'ret-count-desc'

const TabularNewsFeed = ({ newsfeedtrends, setProductsPopupTrend, searchedCategory, searchParams, setSearchParams, showNewmeComponent, forAllTrends, hideTrend, setNewsFeedTrends }) => {
  const showNeckline = useMemo(() => showNecklineColumn(searchedCategory), [searchedCategory])
  const showLength = useMemo(() => showLengthColumn(searchedCategory), [searchedCategory])
  const [trends, setTrends] = useState(newsfeedtrends);
  const userLoggedIn = useSelector(state => state.userLoggedIn)
  const [sort, setSort] = useState(searchParams.get('table-sort') || NOSORTKEY)
  const [loading, setLoading] = useState(false)
  const [retailerKey, setRetailerKey] = useState(`count${searchParams.get('retailertime')}days`)
  const [retailerTime, setRetailerTime] = useState(new Date(new Date().getTime() - 365 * 1000 * 24 * 3600))
  const handleToggleShortlisted = useToggleShortlisted()

  useEffect(() => {
    setRetailerKey(`count${searchParams.get('retailertime')}days`)
    const time = !isNaN(parseInt(searchParams.get('retailertime'))) ? parseInt(searchParams.get('retailertime')) : 365
    setRetailerTime(new Date(new Date().getTime() - time * 1000 * 24 * 3600))
  }, [searchParams.get('retailertime')])


  useEffect(() => {
    if (searchParams.get('table-sort') != sort) {
      setSearchParams(prev => {
        prev.set('table-sort', sort)
        return prev
      })
    }
  }, [sort])



  useEffect(() => {
    let newTrends = newsfeedtrends.filter(t => roundtocloses0_5_value(showFloatToPercentage(t.forecastShare)) >= parseFloat(searchParams.get('min-forecast')))
    setLoading(true)
    if (sort == NOSORTKEY) {
      if (searchParams.get('sort') == 'depth') {
        newTrends = newTrends.sort((a, b) => {
          return b.depth - a.depth
        })
      }
      setTrends(newTrends)
      return
    }
    if (sort && sort.includes('forecast')) {
      newTrends.sort((a, b) => sort == FORECASTASCENDINGSORT ? a.forecastShare - b.forecastShare : b.forecastShare - a.forecastShare)
    } else if (sort && sort.includes('retailer-count')) {
      newTrends.sort((a, b) => sort == RETAILERCOUNTASCENDINGSORT ? a.newmeretailerCount - b.newmeretailerCount : b.newmeretailerCount - a.newmeretailerCount)
    } else if (sort && sort.includes('ret-count')) {
      newTrends.sort((a, b) => sort == TOTALRETAILERCOUNTASCENDINGSORT ? a.retailerCount - b.retailerCount : b.retailerCount - a.retailerCount)
    }
    setTrends(newTrends)
    setLoading(false)
  }, [newsfeedtrends, sort, retailerKey, searchParams.get('min-forecast')])

  function flipForecastSort() {
    setSort(prev => prev != NOSORTKEY && !prev.includes('forecast') ? FORECASTDESCNDINGSORT : prev == NOSORTKEY ? FORECASTDESCNDINGSORT : prev == FORECASTDESCNDINGSORT ? FORECASTASCENDINGSORT : NOSORTKEY)
  }

  function flipRetailerCountSort() {
    setSort(prev => prev != NOSORTKEY && !prev.includes('ret-count') ? TOTALRETAILERCOUNTDESCENDINGSORT : prev == NOSORTKEY ? TOTALRETAILERCOUNTDESCENDINGSORT : prev == TOTALRETAILERCOUNTDESCENDINGSORT ? TOTALRETAILERCOUNTASCENDINGSORT : NOSORTKEY)
  }

  function flipCountSort() {
    setSort(prev => prev != NOSORTKEY && !prev.includes('retailer-count') ? RETAILERCOUNTDESCENDINGSORT : prev == NOSORTKEY ? RETAILERCOUNTDESCENDINGSORT : prev == RETAILERCOUNTDESCENDINGSORT ? RETAILERCOUNTASCENDINGSORT : NOSORTKEY)
  }

  async function toggleShortlisted(onClickEvent) {
    onClickEvent.stopPropagation()

    if (!onClickEvent || !onClickEvent.target || !onClickEvent.target.id)
      return

    const trendId = onClickEvent.target.id.split('shortlist-toggle-')[1]
    const trend = newsfeedtrends.filter(t => t._id == trendId)[0]

    if (!trend)
      return
    const toDelete = trend.shortlisted ? true : false
    const success = await handleToggleShortlisted(trendId, toDelete)
    if (success) {
      setNewsFeedTrends(prev => {
        prev.forEach(trend => {
          if (trend._id == trendId) {
            trend.shortlisted = toDelete ? false : true
          }
        })
        return [...prev]
      })
    }
  }

  return trends.length > 0 ? <table className="border-2 border-separate table table-auto w-full mb-4 border-slate-600 border-spacing-0 border-t-0">
    <thead className={"border bg-slate-300 sticky border-t-2 border-t-slate-600 " + (forAllTrends ? "top-[8.1rem]" : "top-[6rem]")}>
      <tr>
        <th className="border border-slate-500 w-40 text-center px-2   border-y-2 border-t-slate-600">TREND NAME</th>
        <th className="border border-slate-500 w-32 text-center px-2  border-y-2 border-t-slate-600">
          <span>DEMAND FORECAST %</span>
          <button
            onClick={flipForecastSort}
          ><FaSort size={14} color={!sort.includes('forecast') ? 'gray' : 'black'} /></button>
        </th>
        <th className="border border-slate-500 w-48 text-center px-2  border-y-2 border-t-slate-600">EXPLANATION</th>
        <th className="border border-slate-500 w-64 text-center px-2  border-y-2 border-t-slate-600">SOCIAL IMAGES</th>
        {userLoggedIn && userLoggedIn.curator ? <th className="border border-slate-500 w-64 text-center px-2  border-y-2 border-t-slate-600">COORD IMAGES</th> : null}
        <th className="border border-slate-500 w-64 text-center px-2  border-y-2 border-t-slate-600">
          <span>RETAILER IMAGES</span>
          <button
            onClick={flipRetailerCountSort}
          ><FaSort size={14} color={!sort.includes('ret-count') ? 'gray' : 'black'} /></button>
        </th>
        <NewMeComponent showNewme={showNewmeComponent}>
          <th className="border border-slate-500 w-64 text-center px-2  border-y-2 border-t-slate-600 border-l-2 border-l-black">
            <span>{userLoggedIn && userLoggedIn.company == 'trent' ? 'WESTSIDE' : userLoggedIn.company == 'cocoblu' ? "COCOBLU" : 'NEWME'} PRODUCTS</span>
            <button
              onClick={flipCountSort}
            ><FaSort size={14} color={!sort.includes('retailer-count') ? 'gray' : 'black'} /></button>
          </th>
        </NewMeComponent>
        <th className="border border-slate-500 w-64 text-center px-2  border-y-2 border-t-slate-600">
          <span>HISTORICAL BESTSELLERS</span>
          {false ?
            <button
              onClick={flipRetailerCountSort}
            ><FaSort size={14} color={!sort.includes('ret-count') ? 'gray' : 'black'} /></button> : null}
        </th>
        <th className="border border-slate-500 w-auto text-center px-2  border-y-2 border-t-slate-600">SILHOUETTE BREAKDOWN</th>
        {showLength ? <th className="border border-slate-500 w-auto text-center px-2  border-y-2 border-t-slate-600">LENGTH BREAKDOWN</th> : null}
        {showNeckline ? <th className="border border-slate-500 w-auto text-center px-2  border-y-2 border-t-slate-600">NECKLINE BREAKDOWN</th> : null}
      </tr>
    </thead>
    <tbody>
      {trends.map(trend => <tr key={trend._id} className="border-b border-b-slate-600" onClick={() => {
        setProductsPopupTrend(trend)
      }}>
        <td className="text-center px-1 border border-slate-200 text-wrap border-b-slate-600">
          <p className="font-semibold">{trend.value}</p>
          {searchedCategory != trend.category ? <p className="font-extralight">Cat: {trend.category}</p> : null}
          {userLoggedIn && userLoggedIn.curator ? <button onClick={e => {
            e.stopPropagation()
          }}
            className="m-1"
          >
            <a className="font-bold bg-slate-200  rounded p-2 m-1" href={`/news-feed-trend/${encodeURIComponent(trend._id)}`} target="_blank">Add Products</a>
          </button>
            : null}

          {userLoggedIn && userLoggedIn.curator ?
            <div className="flex m-2 my-8" onClick={e => {
              e.stopPropagation()
            }}>
              <label>Hide</label>
              <input type={'checkbox'}
                checked={trend.deleted ? false : true}
                className='sr-only peer'
              />
              <div class="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600 dark:peer-checked:bg-blue-600"
                onClick={() => {
                  hideTrend(trend._id, trend.deleted ? false : true)
                }}
              ></div>
              <label>Show</label>
            </div>
            : null}
          <ShortlistTrend trend={trend} toggleCheckbox={toggleShortlisted} />
        </td>
        <td className="text-center px-1 border border-slate-200 border-b-slate-600">
          {
            trend.tag != "MULTICOLOR"
              ? <>{trend.forecastShare && roundtocloses0_5_value(showFloatToPercentage(trend.forecastShare)) >= 0.5 ? roundtocloses0_5_value(showFloatToPercentage(trend.forecastShare)) : "less than 0.5"}%</>
              : null
          }
        </td>
        <td className="text-center px-1 border border-slate-200 border-b-slate-600">
          {trend.tag != "MULTICOLOR" ? <>          For next two months, {trend.forecastShare && roundtocloses0_5_value(showFloatToPercentage(trend.forecastShare)) >= 0.5 ? roundtocloses0_5_value(showFloatToPercentage(trend.forecastShare)) : "less than 0.5"}% of your {trend.category} should be {trend.value} ({SentenceCase(trend.tag)}).</> : null}
        </td>
        <td className="border-slate-200 border-b-slate-600 border">
          <div className="w-full h-full flex flex-wrap justify-center ">
            {trend.images ? trend.images.slice(0, 4).map(image => <div className="w-28 h-48 p-0.5 flex justify-center items-start max-w-[50%]" key={image.mediaId}>
              <img src={image.imageUrl} className='max-w-full max-h-full object-contain' loading="lazy" />
            </div>) : null}
          </div>
        </td>

        {userLoggedIn && userLoggedIn.curator ? <td className="border-slate-200 border-b-slate-600 border">
          <div className="w-full h-full flex flex-wrap justify-center " onClick={(e) => {
            e.stopPropagation()
            setProductsPopupTrend({ ...trend, iscoord: true })
          }}>
            {trend.coordProducts ? <div className="w-full text-center font-semibold shrink-0">{false ? trend.coordProducts.count : null} Coord Images</div> : null}
            {trend.coordProducts && trend.coordProducts.images ? trend.coordProducts.images.slice(0, 4).map(image => <div className="w-28 h-48 p-0.5 flex justify-center items-start max-w-[50%]" key={image}>
              <img src={image} className='max-w-full max-h-full object-contain' loading="lazy" />
            </div>) : null}
          </div>
        </td> : null}
        <td className="border-slate-200 border-b-slate-600 border align-top" key={`${retailerKey}-${trend._id}`}>
          <TabularDataRetailerCell retailerKey={retailerKey} trend={trend} time={retailerTime} />
        </td>
        <NewMeComponent showNewme={showNewmeComponent}>

          <td className="border-slate-200 border-b-slate-600 border align-top"
            onClick={(e) => {
              e.stopPropagation()
              setProductsPopupTrend({ ...trend, productsRetailer: (userLoggedIn && userLoggedIn.company && companyToRetailer[userLoggedIn.company] ? companyToRetailer[userLoggedIn.company] : 'newme') })
            }}>
            <NewmeTabularDataRetailerCell retailerKey={retailerKey} trend={trend} company={userLoggedIn ? (userLoggedIn.curator ? 'newme' : userLoggedIn.company == 'trent' ? 'westside' : userLoggedIn.company) : ''} time={retailerTime} />
          </td>
        </NewMeComponent>
        <td className="border-slate-200 border-b-slate-600 border align-top" >
          <div className="w-full h-full flex flex-wrap justify-center align-top " onClick={e => {
            e.stopPropagation()
          }}>
            <p className="w-full shrink-0 text-center">{trend.reviewedProductsCount ? trend.reviewedProductsCount : 0} products</p>
            {trend.reviewedProducts ? trend.reviewedProducts.slice(0, 4).map(image => <a className="w-28 h-48 p-0.5 flex justify-center items-start max-w-[50%]" key={image.productUrl} href={image.productUrl} target="_blank">
              <img src={image.imageUrl} className='max-w-full max-h-full object-contain' loading="lazy" />
            </a>) : null}
          </div>
        </td>
        <td className="text-center px-1 border border-slate-200 border-b-slate-600 text-wrap">
          {trend.silhouetteShare ? <SilhouetteShare silhouetteShare={trend.silhouetteShare} heading={''} icon={null} setImagePopupData={() => { }} trend={trend} /> : null}
        </td>
        {showLength ? <td className="text-center px-1 border border-slate-200 border-b-slate-600 text-wrap">
          {trend.secondaryTagsShare ? trend.secondaryTagsShare.filter(t => t.values.length > 0 && ['BOTTOM LENGTH', 'TOP LENGTH'].includes(t.tag)).map(secondaryTag => <SilhouetteShare silhouetteShare={secondaryTag.values} tag={secondaryTag.tag} icon={null} setImagePopupData={() => { }} trend={trend} />) : null}
        </td> : null}
        {showNeckline ? <td className="text-center px-1 border border-slate-200 border-b-slate-600 text-wrap">
          {trend.secondaryTagsShare ? trend.secondaryTagsShare.filter(t => t.values.length > 0 && ['NECKLINE'].includes(t.tag)).map(secondaryTag => <SilhouetteShare silhouetteShare={secondaryTag.values} tag={secondaryTag.tag} icon={null} setImagePopupData={() => { }} trend={trend} />) : null}
        </td> : null}




      </tr>)}

    </tbody>

  </table> : null
}

export default TabularNewsFeed
